import { supabase } from "@/lib/supabaseClient";

export type OnboardingStatus = {
  completedAt: string | null;
  isCompleted: boolean;
};

/** 프로필 행이 없으면 아직 온보딩을 완료하지 않은 신규 사용자다. */
export async function getOnboardingStatus(userId: string): Promise<OnboardingStatus> {
  const { data, error } = await supabase
    .from("profiles")
    .select("onboarding_completed_at")
    .eq("id", userId)
    .maybeSingle();

  if (error) {
    throw error;
  }

  const completedAt = data?.onboarding_completed_at ?? null;

  return { completedAt, isCompleted: completedAt !== null };
}

/** 완료 시각을 서버에 저장해 재설치·기기 변경 후에도 다시 노출되지 않게 한다. */
export async function completeOnboarding(userId: string): Promise<string> {
  const completedAt = new Date().toISOString();
  const { error } = await supabase
    .from("profiles")
    .upsert({ id: userId, onboarding_completed_at: completedAt }, { onConflict: "id" });

  if (error) {
    throw error;
  }

  return completedAt;
}
